import { Injectable } from '@angular/core';

import confetti from 'canvas-confetti';

@Injectable({
  providedIn: 'root',
})
export class CanvasConfettiService {
  private zIndex = 2147483000;

  public show(options?: confetti.Options): void {
    confetti(options);
  }

  public basicCannon(): void {
    this.show({
      zIndex: this.zIndex,
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
    });
  }

  public realisticLook(count: number): void {
    const defaultOptions = {
      origin: { y: 0.7 },
      zIndex: this.zIndex,
    };

    this.show({
      ...defaultOptions,
      spread: 26,
      startVelocity: 55,
      particleCount: Math.floor(count * 0.25),
    });
    this.show({
      ...defaultOptions,
      spread: 60,
      particleCount: Math.floor(count * 0.2),
    });
    this.show({
      ...defaultOptions,
      spread: 100,
      decay: 0.91,
      scalar: 0.8,
      particleCount: Math.floor(count * 0.35),
    });
    this.show({
      ...defaultOptions,
      spread: 120,
      startVelocity: 25,
      decay: 0.92,
      scalar: 1.2,
      particleCount: Math.floor(count * 0.1),
    });
    this.show({
      ...defaultOptions,
      spread: 120,
      startVelocity: 45,
      particleCount: Math.floor(count * 0.1),
    });
  }

  public fireworks(duration = 1400): () => void {
    const animationEnd = Date.now() + duration;
    const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: this.zIndex };

    const interval: ReturnType<typeof setInterval> = setInterval(() => {
      const timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        return clearInterval(interval);
      }

      const particleCount = 100 * (timeLeft / duration);
      this.show({
        ...defaults,
        particleCount,
        origin: { x: this.randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
      });
      this.show({
        ...defaults,
        particleCount,
        origin: { x: this.randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
      });
    }, 350);

    return () => clearInterval(interval);
  }

  private randomInRange(min: number, max: number): number {
    return Math.random() * (max - min) + min;
  }
}
